/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService
 */
import * as References from './TranscriptPropertyUpdateSuggestionsService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsForSource
 */
export const GET_PROPERTY_SUGGESTIONS_FOR_SOURCE_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsForSource';
export const GET_PROPERTY_SUGGESTIONS_FOR_SOURCE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_FOR_SOURCE_QUERY_FIELD_NAME,
  args: ['sourceObjectTypeId', 'sourceObjectId', 'transcriptSuggestionFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPropertySuggestionsForSourceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsForSourceBatch
 */
export const GET_PROPERTY_SUGGESTIONS_FOR_SOURCE_BATCH_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsForSourceBatch';
export const GET_PROPERTY_SUGGESTIONS_FOR_SOURCE_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_FOR_SOURCE_BATCH_QUERY_FIELD_NAME,
  args: ['sources', 'filters'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPropertySuggestionsForSourceBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#setUserDecisionV2
 */
export const SET_USER_DECISION_V2_MUTATION_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_setUserDecisionV2';
export const SET_USER_DECISION_V2_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_USER_DECISION_V2_MUTATION_FIELD_NAME,
  args: ['runId', 'objectTypeId', 'objectId', 'suggestionDecisionInputs', 'additionalPropertyUpdates'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.setUserDecisionV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#triggerTranscriptAnalysis
 */
export const TRIGGER_TRANSCRIPT_ANALYSIS_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_triggerTranscriptAnalysis';
export const TRIGGER_TRANSCRIPT_ANALYSIS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: TRIGGER_TRANSCRIPT_ANALYSIS_QUERY_FIELD_NAME,
  args: ['sourceObjectTypeId', 'sourceObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.triggerTranscriptAnalysisRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsForRecord
 */
export const GET_PROPERTY_SUGGESTIONS_FOR_RECORD_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsForRecord';
export const GET_PROPERTY_SUGGESTIONS_FOR_RECORD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_FOR_RECORD_QUERY_FIELD_NAME,
  args: ['objectTypeId', 'objectId', 'emailThreadId', 'transcriptSuggestionFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getPropertySuggestionsForRecordRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPendingSuggestionsForRecord
 */
export const GET_PENDING_SUGGESTIONS_FOR_RECORD_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPendingSuggestionsForRecord';
export const GET_PENDING_SUGGESTIONS_FOR_RECORD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PENDING_SUGGESTIONS_FOR_RECORD_QUERY_FIELD_NAME,
  args: ['objectTypeId', 'objectId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getPendingSuggestionsForRecordRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsForPortal
 */
export const GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsForPortal';
export const GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['transcriptSuggestionFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getPropertySuggestionsForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsForPortalPaginated
 */
export const GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsForPortalPaginated';
export const GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_PAGINATED_QUERY_FIELD_NAME,
  args: ['transcriptSuggestionFilters', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getPropertySuggestionsForPortalPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsForPortalByObjectPaginated
 */
export const GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_BY_OBJECT_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsForPortalByObjectPaginated';
export const GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_BY_OBJECT_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_FOR_PORTAL_BY_OBJECT_PAGINATED_QUERY_FIELD_NAME,
  args: ['transcriptSuggestionFilters', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getPropertySuggestionsForPortalByObjectPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPropertySuggestionsCount
 */
export const GET_PROPERTY_SUGGESTIONS_COUNT_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPropertySuggestionsCount';
export const GET_PROPERTY_SUGGESTIONS_COUNT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROPERTY_SUGGESTIONS_COUNT_QUERY_FIELD_NAME,
  args: ['transcriptSuggestionFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getPropertySuggestionsCountRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getSmartDataCaptureCitation
 */
export const GET_SMART_DATA_CAPTURE_CITATION_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getSmartDataCaptureCitation';
export const GET_SMART_DATA_CAPTURE_CITATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SMART_DATA_CAPTURE_CITATION_QUERY_FIELD_NAME,
  args: ['suggestionIds'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getSmartDataCaptureCitationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#setUserReviewSource
 */
export const SET_USER_REVIEW_SOURCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_setUserReviewSource';
export const SET_USER_REVIEW_SOURCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_USER_REVIEW_SOURCE_MUTATION_FIELD_NAME,
  args: ['runIds', 'userReviewSource'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.setUserReviewSourceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#recordSuggestionViews
 */
export const RECORD_SUGGESTION_VIEWS_MUTATION_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_recordSuggestionViews';
export const RECORD_SUGGESTION_VIEWS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RECORD_SUGGESTION_VIEWS_MUTATION_FIELD_NAME,
  args: ['suggestionIdsByRunId', 'userReviewSource'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.recordSuggestionViewsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#updateSuggestionMetadata
 */
export const UPDATE_SUGGESTION_METADATA_MUTATION_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_updateSuggestionMetadata';
export const UPDATE_SUGGESTION_METADATA_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SUGGESTION_METADATA_MUTATION_FIELD_NAME,
  args: ['updates'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.updateSuggestionMetadataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#triggerPreviewAnalysis
 */
export const TRIGGER_PREVIEW_ANALYSIS_MUTATION_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_triggerPreviewAnalysis';
export const TRIGGER_PREVIEW_ANALYSIS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: TRIGGER_PREVIEW_ANALYSIS_MUTATION_FIELD_NAME,
  args: ['targetObjectTypeId', 'targetPropertyName', 'targetPropertyDescription', 'targetPropertyDataEntryInstructions', 'targetPropertyOptionDescriptions', 'sourceObjectTypeId', 'sourceObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.triggerPreviewAnalysisRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getPreviewGeneration
 */
export const GET_PREVIEW_GENERATION_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getPreviewGeneration';
export const GET_PREVIEW_GENERATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PREVIEW_GENERATION_QUERY_FIELD_NAME,
  args: ['previewId'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getPreviewGenerationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#getRunProperties
 */
export const GET_RUN_PROPERTIES_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_getRunProperties';
export const GET_RUN_PROPERTIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RUN_PROPERTIES_QUERY_FIELD_NAME,
  args: ['runId'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getRunPropertiesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService#searchSdcSuggestions
 */
export const SEARCH_SDC_SUGGESTIONS_QUERY_FIELD_NAME = 'com_hubspot_ai_context_mining_rpc_TranscriptPropertyUpdateSuggestionsService_searchSdcSuggestions';
export const SEARCH_SDC_SUGGESTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_SDC_SUGGESTIONS_QUERY_FIELD_NAME,
  args: ['filterGroups', 'targetObjectFilter', 'count'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.searchSdcSuggestionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});